import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { authApi } from "@/api/authApi";

const GoogleSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Fix double slash issue in URL
    const pathname = window.location.pathname;
    if (pathname.includes("//")) {
      const normalizedPath = pathname.replace(/\/\//g, "/");
      window.history.replaceState(
        null,
        "",
        normalizedPath + window.location.search + window.location.hash
      );
    }

    const fetchToken = async () => {
      try {
        const pathSegments = window.location.pathname
          .split("/")
          .filter((segment) => segment !== "");
        const token = pathSegments[pathSegments.length - 1];
        if (!token) {
          throw new Error("No token found");
        }

        const response = await authApi.googleSuccess(token);

        if (response.status !== 200) {
          const errorData = response.data;
          throw new Error(
            errorData.message || `HTTP error! status: ${response.status}`
          );
        }

        const data = response.data;
        console.log("data", data);
        console.log("data.accessToken", data.access_token);
        // Store tokens if needed
        if (data.access_token) {
          try {
            localStorage.setItem("access_token", data.access_token);
            localStorage.setItem("refresh_token", data.refresh_token);
            Cookies.set("access_token", data.access_token);
          } catch (storageError) {
            console.warn("Unable to access localStorage:", storageError);
            // Consider alternative storage methods or handle the error appropriately
          }
        }
        // Navigate to post-login handler which will show stepper if needed
        navigate("/post-login");
      } catch (error) {
        toast.error(`Error details: ${error}`);
        console.error("Error details:", error);
        // navigate("/login");
      }
    };

    fetchToken();
  }, [navigate]);

  return (
    <div className="flex justify-center items-center h-screen">
      Processing login...
    </div>
  );
};

export default GoogleSuccess;
